var map = {
	"./DocPage": [
		478960,
		71869,
		55649,
		86373,
		71352,
		43939,
		8697,
		39926
	],
	"./DocPage.tsx": [
		478960,
		71869,
		55649,
		86373,
		71352,
		43939,
		8697,
		39926
	],
	"./ProductPage": [
		659739,
		93414,
		59739
	],
	"./ProductPage.tsx": [
		659739,
		93414,
		59739
	],
	"./RecipePage": [
		855732,
		3378
	],
	"./RecipePage.tsx": [
		855732,
		3378
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 452644;
module.exports = webpackAsyncContext;